import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { TypedMemo } from '../../../common/types';
import { SMLRouteParts } from '../../../../routing/sml/SMLRoutes';
import { SMLLink } from '../SMLLink/SMLLink';
import { smlNavigationChromeMessages } from '../../navigation/smlNavigationMessages';
import styles from './SMLBackLink.module.scss';

interface SMLBackLinkProps {
  to: SMLRouteParts;
  params?: Record<string, string>;
  /** The page it goes back to: "Posts". */
  destination: string;
  /**
   * Replaces the navigation of the link, for example a history step back (Charts details). The
   * `href` still names `to`.
   */
  onClick?: () => void;
}

/**
 * "‹ Posts": the back link of a page under a menu item (design navigation-v2 3d, 4e, 5c). Such a
 * page has its own title and no tabs; the link names the item it belongs to.
 */
const SMLBackLinkComponent: React.FC<SMLBackLinkProps> = ({ to, params, destination, onClick }) => {
  const intl = useIntl();
  return (
    <SMLLink
      to={to}
      params={params}
      className={styles.back}
      onClick={onClick === undefined ? undefined : () => onClick()}
      ariaLabel={intl.formatMessage(smlNavigationChromeMessages.back, { destination })}
    >
      <FontAwesomeIcon icon={faChevronLeft} />
      {destination}
    </SMLLink>
  );
};

export const SMLBackLink = TypedMemo(SMLBackLinkComponent);
